const GENERAL_SETTING_ACTION = {
  GET_GENERAL_SETTING_REQUEST: "GET_GENERAL_SETTING_REQUEST",
  GET_GENERAL_SETTING_SUCCESS: "GET_GENERAL_SETTING_SUCCESS",
  GET_GENERAL_SETTING_ERROR: "GET_GENERAL_SETTING_ERROR",
};
export default GENERAL_SETTING_ACTION;
